export const SET_PAGES = "SET_PAGES";
export const SET_API = "SET_API";
export const SET_ID_CHECK = "SET_ID_CHECK";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_DEVELOPMENTS = "SET_DEVELOPMENTS";
export const SET_DEVELOPMENTS_PROPERTIES = "SET_DEVELOPMENTS_PROPERTIES";
export const SET_SPLASHDATA = "SET_SPLASHDATA";
